import { useQuery } from 'react-query';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

// Constants
import { rutasCotizarCatolica } from '../../../../common/constants';

// Hooks
import { CotizadorProvider } from '../../../../hooks/context';

// Pages
import {
  Cotizar,
  Error404,
  Error500,
  FormularioCotizar,
  Informativa,
  PreguntasFrecuentes,
  TerminosCondiciones,
} from '../../../pages';

// Templates
import { Layout } from '../../../templates';

// Utils
import { changeSEO } from '../../../../core/utils';

export function RouterCatolica() {
  const location = useLocation();

  useQuery({
    queryKey: ['seo', location.pathname],
    queryFn: changeSEO,
  });

  return (
    <Layout>
      <Routes>
        <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
        <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
        <Route path="/seguro-plenisalud-hilc" element={<Informativa />} />
        <Route
          path="/cotizar"
          element={
            <CotizadorProvider>
              <Cotizar />
            </CotizadorProvider>
          }
        />
        {rutasCotizarCatolica.map(ruta => (
          <Route
            key={ruta.codigo}
            path={ruta.ruta}
            element={
              <CotizadorProvider>
                <FormularioCotizar />
              </CotizadorProvider>
            }
          />
        ))}
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route
          path="/"
          element={<Navigate to="/cotizar-seguro-plenisalud-hilc" replace />}
        />
        <Route path="*" element={<Navigate to="/page-error-404" replace />} />
      </Routes>
    </Layout>
  );
}
